module.exports = __webpack_public_path__ + "img/res-person.1e31dfea.svg";